import {AddressModel} from "../core/address";

class AdminAddressModel extends AddressModel {

    distanceFrom(address, options) {

        if (!this.dists) {
            this.dists = [];
        }
        if (!this.dists[address]) {
            this.dists[address] = Math.round(Math.random() * 50, 0);
        }
        return this.dists[address];
    }
}

export {
    AdminAddressModel
}